import type { AccesoGuardado } from './accesoGuardado';
import { esApp } from './plataforma';

/**
 * El NIF y la contraseña que se acaban de escribir en el login, para que la ventanita
 * «¿Entrar con Face ID la próxima vez?» pueda guardarlos si el usuario acepta.
 *
 * Solo en la app, solo en memoria (nunca en disco) y de un solo uso: quien lo toma lo borra.
 */
let pendiente: AccesoGuardado | null = null;

export const recordarAccesoTrasLogin = (acceso: AccesoGuardado): void => {
	if (esApp()) {
		pendiente = acceso;
	}
};

export const tomarAccesoTrasLogin = (): AccesoGuardado | null => {
	const acceso = pendiente;
	pendiente = null;

	return acceso;
};
